import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";

export default class RespinTransitions extends AbstractSceneTransition {

    public in(): Contract<void> {
        // Layers.Custom.get("Respin").getSprite("rainbow").visible = false;
        // Layers.Custom.get("Respin").getSprite("rainbow2").visible = false;
        return Contract.empty();
    }

    public out(): Contract<void> {
        return Contract.empty();
    }

    public destroy() {
        super.destroy();
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/respin-transitions.ts